import Grid from "@mui/material/Grid";
import FormField from "../../../layouts/ecommerce/products/new-product/components/FormField";

// Material Dashboard 2 PRO React components
import MDBox from "../../../components/MDBox";

export default function PreparationForth({ prepaCommentary, setPrepaCommentary, edit }) {
  return (
    <MDBox>
      <Grid container spacing={2}>
        <Grid item container xs={12}>
          <Grid item xs={12}>
            <FormField
              value={prepaCommentary}
              onChange={(event) => setPrepaCommentary(event.target.value)}
              type="text"
              minRows={2}
              multiline="true"
              variant="outlined"
              label="Commentaire de préparation"
            />
          </Grid>
        </Grid>
      </Grid>
    </MDBox>
  );
}
